import moment from 'moment-timezone'
import { DATE_ONLY_FORMAT, dateHelper, DEFAULT_DATE_VALUE_FORMAT } from '../../../utils/dateUtils'
import { tabNames } from '@/pages/member/Constants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const visitTypesNameHandler = (availability) => {
  const visitTypesArr = [...availability.VisitTypes]
  const licenseStateListArr = [...availability.StateCodes]

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const visitTypeNameWithStatesHandler = (availabilityVisitType) => {
    if (licenseStateListArr.length > 1 && availabilityVisitType.StateCodes.length !== licenseStateListArr.length) {
      return {
        ...availabilityVisitType,
        Name: `${availabilityVisitType.Name}(*${availabilityVisitType.StateCodes.join('; ')} only)`,
      }
    }
    return { ...availabilityVisitType }
  }
  return { ...availability, VisitTypes: visitTypesArr?.map(visitTypeNameWithStatesHandler) }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getCorrectViewFormatOfDateInSelectDateTool = (date) => moment(date).format(DATE_ONLY_FORMAT)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function toTimeZone(time, zone) {
  return moment(time)?.tz(zone)
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getValueOfNewSearchParamsByFieldName = ({ queryValue, fieldName, searchParams }) => {
  const query = queryValue ? { [fieldName]: queryValue } : {}
  const { [fieldName]: _, ...lastQueries } = Object.fromEntries(searchParams)
  return { ...lastQueries, ...query, tab: tabNames.CALENDAR }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isValidDate = (dateString) => dateHelper.isValidDate(dateString, DEFAULT_DATE_VALUE_FORMAT)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateCorrectDateForCalendar = (value, customTimeZone) => {
  const newCalendarValue = toTimeZone(value, customTimeZone)
  const dateStringValue = moment(value)
  const days = newCalendarValue.dayOfYear()
  const daysOfInitialDate = dateStringValue.dayOfYear()
  if (days < daysOfInitialDate) {
    newCalendarValue.add(1, 'days')
  }
  return newCalendarValue
}
